import React from 'react';
import Footer from "../components/Footer";

function Privacy() {
  return (
    <>
      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Privacy Policy</h1>
          <p className="mt-2 text-sm text-gray-500">Effective date: January 1, {new Date().getFullYear()}</p>

          <div className="mt-10 space-y-8 text-base leading-7 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900">Overview</h2>
              <p className="mt-3">
                Astoria Labs is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard information when you visit our website or use our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Information We Collect</h2>
              <p className="mt-3">
                We may collect information that you provide directly, such as your name, email address, and any details you submit through our contact forms or scheduling tools. We may also collect information automatically, including browser type, device information, pages visited, and referring URLs through standard web technologies such as cookies and analytics tools.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">How We Use Your Information</h2>
              <p className="mt-3">
                We use the information we collect to provide, maintain, and improve our services, respond to your inquiries, communicate with you about our offerings, and analyze how our site is used. We may also use this information to comply with legal obligations and protect our rights.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Cookies and Tracking</h2>
              <p className="mt-3">
                Our site may use cookies and similar technologies to enhance your experience, analyze site traffic, and understand usage patterns. You can control cookie preferences through your browser settings. Disabling cookies may affect the functionality of certain features.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Third-Party Services</h2>
              <p className="mt-3">
                We may use third-party services for analytics, scheduling, and communication. These services may collect information in accordance with their own privacy policies. We encourage you to review the privacy practices of any third-party services you interact with through our site.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Data Sharing</h2>
              <p className="mt-3">
                We do not sell your personal information. We may share information with trusted service providers who assist us in operating our site and conducting our business, provided they agree to keep such information confidential. We may also disclose information when required by law or to protect our rights.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Data Security</h2>
              <p className="mt-3">
                We take reasonable measures to protect the information we collect from unauthorized access, alteration, or destruction. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Your Choices</h2>
              <p className="mt-3">
                You may choose not to provide certain information, though this may limit your ability to use some features of our site. You may also opt out of receiving promotional communications from us by following the instructions in those messages.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900">Changes to This Policy</h2>
              <p className="mt-3">
                We may update this Privacy Policy from time to time. Any changes will be reflected on this page with an updated effective date. Your continued use of the site after changes are posted constitutes your acceptance of the revised policy.
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Privacy;
